import { Box, Button, Divider, Modal, Typography } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import React from 'react';
import apis from '../Services/api-services';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { RotatingLines } from 'react-loader-spinner';
import { TRANSLATIONS } from '../Utils/translations';
import { useTranslation } from 'react-i18next';

const buttonEnums = {
  Home: 'Go to homescreen',
  RealtorProfile: `View Profile`,
  PropertyDetails: `View Property`,
  ChatListings: 'Go to Messages',
  ListProperty: 'Add Property',
};

export default function Notifications({
  open,
  onClose,
  notifications,
  getNotifications,
  isLoading,
  notificationsCount,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();


  const markAllNotifications  = async()=>{
    const response = await apis.notification.markReadAllNotification();
    if (response?.data?.status === 'success') {
      getNotifications();
    }
  }

  const handleMarkReadNotification = async (notificationId) => {
    const response = await apis.notification.markReadNotification({
      notificationId,
    });
    if (response?.data?.status === 'success') {
      getNotifications();
    }
  };

  const markReadNotification = async (data) => {
    const params = JSON.parse(data?.params || null);
    const notificationId = params?.notification_id;
    if (notificationId) {
      await handleMarkReadNotification(notificationId);
    }
  }

  const handleNavigateOnNotificationClick = async (data) => {
    const params = JSON.parse(data?.params || null);
    const propertyId = params?.property_id || params?.propertyId;
    const notificationId = params?.notification_id;

    if (notificationId) {
      await handleMarkReadNotification(notificationId);
    }

    const routes = {
      Home: '/',
      RealtorProfile: `/profile`,
      PropertyDetails: `/property/${propertyId}`,
      ChatListings: '/messages',
      ChatDetails: `/messages`, //Messages recived from lead/unlocked
      ListProperty: '/add-property',
      RequirementList: '/requirements?tab=1',
    };

    let obj = {};
    if (data?.screen === 'ChatDetails' || data?.screen === 'ChatListings') {
      let tempObj = {
        chat_room: params.chatRoomID,
        cover_picture: null,
        owner_name: params.createdBy,
        property_title: params.propertyName,
        broker_id: params.brokerId,
        property_id: {},
        selectedTab: params.selectedTab,
      };
      obj = tempObj;
    }

    if (data?.screen) {
      onClose();
      if (obj && Object.keys(obj).length > 0) {
        navigate(routes[data?.screen], { state: obj });
      } else {
        navigate(routes[data?.screen]);
      }
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          maxHeight: 800,
          position: { lg: 'absolute', xs: 'relative' },
          right: { lg: '10%' },
          top: { lg: '10%' },
          width: { lg: '42%', xs: '96%' },
          margin: { xs: '12px auto' },
          outline: 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '2rem 1rem 1rem 1rem',
          }}
        >
          <Typography
            sx={{
              marginRight: '1rem',
              color: '#474747',
              fontSize: '18px',
              fontWeight: '600',
            }}
          >
            {t(TRANSLATIONS.TITLES.NOTIFICATIONS)}{' '}
            {notificationsCount ? `(${notificationsCount})` : ''}
            {notificationsCount > 0 && <Button sx={{ textTransform: 'capitalize', ml: 1 }} onClick={()=>markAllNotifications()}>
              Clear All
            </Button>}
          </Typography>

          <IconX
            strokeWidth="1.5"
            size="32"
            style={{
              cursor: 'pointer',
              background: '#cfcfcf',
              borderRadius: '50%',
              padding: '5px',
            }}
            onClick={() => onClose()}
          />
        </Box>

        <Box>
          <Divider sx={{ margin: '0 1rem 1rem 1rem' }} />
        </Box>

        {isLoading ? (
          <Box sx={{ display: 'flex' }}>
            <Typography
              sx={{ color: '#7D7D7D', padding: '1rem 1rem 1rem 1rem' }}
            >
              {t(TRANSLATIONS.SUB_TITLES.LOADING_NOTIFICATIONS)}
            </Typography>

            <RotatingLines
              visible={isLoading}
              height="24"
              width="24"
              strokeColor="#600DB4"
              strokeWidth="5"
              animationDuration="0.7"
            />
          </Box>
        ) : (
          <Box sx={{ maxHeight: '500px', overflow: 'scroll' }}>
            {notifications?.length > 0 ? (
              notifications.map((notification, index) => (
                <Box
                  key={index}
                  sx={{
                    cursor: 'pointer',
                    position: 'relative',
                    ':hover': {
                      backgroundColor: '#F5EDFF',
                      '.icon-wrapper': {
                        display: 'block',
                      },
                    },
                  }}
                >
                  <Box
                    sx={{ padding: '1rem 1rem' }}
                    onClick={() => {
                      handleNavigateOnNotificationClick(notification?.data);
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '16px',
                        color: '#474747',
                        fontWeight: '600',
                      }}
                    >
                      {notification?.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: '#474747',
                      }}
                    >
                      {notification?.message}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: '4px' }}>
                        <Typography sx={{ color: '#7D7D7D', fontSize: '14px' }}>
                          {dayjs(notification?.created_at).format('DD/MM/YYYY')}{' '}
                          |{' '}
                        </Typography>
                        <Typography sx={{ color: '#7D7D7D', fontSize: '14px' }}>
                          {dayjs(notification?.created_at).format('hh:mm A')}
                        </Typography>
                      </Box>
                      {buttonEnums[notification?.data?.screen] && (
                        <Button
                          variant="text"
                          onClick={() =>
                            handleNavigateOnNotificationClick(
                              notification?.data
                            )
                          }
                          sx={{
                            color: '#600DB4',
                            fontSize: '14px',
                            textTransform: 'initial',
                            textDecoration: 'underline',
                          }}
                        >
                          {buttonEnums[notification?.data?.screen] ||
                            'Click here'}
                        </Button>
                      )}
                    </Box>
                  </Box>

                  <Box
                    className="icon-wrapper"
                    sx={{
                      display: 'none',
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      markReadNotification(notification?.data)
                    }}
                  >
                    <IconX
                      strokeWidth="1.5"
                      size="22"
                      style={{
                        cursor: 'pointer',
                        background: '#cfcfcf',
                        borderRadius: '50%',
                        padding: '5px',
                      }}
                    />
                  </Box>

                  <Box>
                    <Divider sx={{ marginBotom: '1rem' }} />
                  </Box>
                </Box>
              ))
            ) : (
              <Typography
                sx={{ color: '#7D7D7D', padding: '1rem 1rem 1rem 1rem' }}
              >
                {t(TRANSLATIONS.SUB_TITLES.NO_NOTIFICATION_FOUND)}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
}
